import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.png'
import five from '../assets/svg/projects/five.svg'
import ebud from '../assets/svg/projects/ebud.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'eBuds',
        projectDesc: 'eBuds is an online collection of 30 cannabis strains, each with its own background and decorations. 1,000 unique NFTs have been generated.',
        tags: ['eBuds', 'buds', 'weed'],
        code: 'https://superciety.com/fellowships/ebuds',
        demo: 'https://isengard.market/collection/BUD-3ee0cf',
        image: ebud
    },
    {
        id: 2,
        projectName: 'SuperVictor',
        projectDesc: 'At just 11 months old, Victor suffers from Type 1 SMA(spinal muscular amyotrophy)',
        tags: ['Together','for Victor' ],
        code: 'https://twitter.com/Together4Victor',
        demo: 'https://www.frameit.gg/marketplace/SUPERVIC-f07785/items',
        image: five
    },
 
    {
        id: 3,
        projectName: 'Gokai Labs',
        projectDesc: 'Maiar Ghosts is an 8658 unique Mr Ghost NFT collection on the Elrond blockchain. .',
        tags: ['Maiar', 'Ghosts'],
        code: 'https://gokai.org/',
        demo: 'https://xoxno.com/collection/MRG-1c3ba4',
        image: two
    },
    {
        id: 4,
        projectName: 'Seed Captain',
        projectDesc: 'Seed Captain is the first incubator in the Elrond ecosystem, the place where quality ideas can find the necessary financing at the beginning of their journey.',
        tags: ['Water', 'Fire', 'Capitan'],
        code: 'https://seedcaptain.io/',
        demo: 'https://deadrare.io/collection/CTPWATER-e268f8',
        image: three
    },
    {
        id: 5,
        projectName: 'Web3 Pirates',
        projectDesc: '6969 Web3 Pirates sailing on Water',
        tags: ['Web3 Pirates', 'Web3 Crew'],
        code: 'https://www.web3pirates.com/',
        demo: 'https://xoxno.com/collection/W3P-48cc5a',
        image: four
    },
    {
        id: 6,
        projectName: 'Evoluzion.Life',
        projectDesc: 'This project aims to bridges the boundaries between ART and TECH ',
        tags: ['Primates', 'Humans', 'Cyborgs'],
        code: 'https://evoluzion.life',
        demo: 'https://xoxno.com/collection/EVZ-7e2105',
        image: one
    },
 
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/